import React from 'react';
import HomeSingleSlide from '../../../components/HomeSingleSlide/HomeSingleSlide';
import Slider from "react-slick";

const HomeHeroSlider = () => {
   // slider setting
   const settings = {
      autoplay: true,
      autoplaySpeed: 8000,
      speed: 500,
      // Only one slide is ever rendered below, so there's nothing to loop —
      // infinite mode was triggering react-slick's clone-generation logic for
      // no functional benefit, and its clones' inline positioning styles were
      // unstable between the prerendered snapshot and a fresh client render,
      // tripping React 18's stricter hydration mismatch handling.
      infinite: false,
      dots: false,
      fade: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
   };

   return (
      <>
         <section className="slider__area slider__area-2">
            <Slider className='slider-active' {...settings}>
               <HomeSingleSlide slider_class="tw-w-full tw-px-3 sm:tw-w-10/12 sm:tw-ml-[5.6667%] md:tw-w-9/12 md:tw-ml-[25%] lg:tw-w-8/12 lg:tw-ml-[33.3333%] xl:tw-w-7/12 xl:tw-ml-0" content_class="" attr_1={<span className='subtitle'>Driving Success</span>} attr_2={<h1 >Crafting Seamless <br /> Digital Solutions</h1>} />
            </Slider>
         </section>
      </>
   );
};

export default HomeHeroSlider;